import Quill from 'quill';
import type Toolbar from 'quill/modules/toolbar';

export default function handler(this: Toolbar) {
  const range = this.quill.getSelection(true);
  const dividerDelta = this.quill.insertEmbed(range.index + 1, 'divider', true, Quill.sources.USER);
  this.quill.setSelection(dividerDelta.length() + 2, Quill.sources.SILENT);
}
